import { createSlice } from "@reduxjs/toolkit";
import { updateNotificationCount, userActivities } from "../../services/activities";

const initialState = {
  activity: [],
  notificationCount: 0,
  loading: false,
  status: "",
  error: "",
};

export const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userActivities.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(userActivities.fulfilled, (state, action) => {
        return {
          ...state,
          activity: action.payload,
          loading: false,
        };
      })
      .addCase(userActivities.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

    builder.addCase(updateNotificationCount, (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    });
  },
});

export default activitySlice.reducer;
